import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import { BsSearch } from 'react-icons/bs';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import { Modal } from 'react-bootstrap';
import { startsWith } from 'components/common/utils';
import { DELETE_OEM_VENDOR, FETCH_OEM_VENDOR, GET_OEM_VENDOR } from 'actions/oemVendor';
import OemVendorForm from './OemVendorForm';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import DeleteModal from 'components/general/DeleteModal';
import { BiSort } from 'react-icons/bi';

const OemVendorList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [allOemVendorData, setAllOemVendorData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [oemId, setOemId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseOemVendorData, setPageWiseOemVendorData] = useState([]);

  const page = useSelector((state) => state.oemVendor.page);
  const totalData = useSelector((state) => state.oemVendor.total);
  const limit = useSelector((state) => state.oemVendor.limit);
  const totalPages = useSelector((state) => state.oemVendor.totalPages);
  const oemVendorList = useSelector((state) => state.oemVendor.oemVendors);
  const isLoader = useSelector((state) => state.oemVendor.isLoading);

  const oemVendorData = oemVendorList.filter(({ id: id1 }) => pageWiseOemVendorData.some(({ id: id2 }) => id2 === id1));

  const deleteOemVendor = useCallback(
    () =>
      dispatch({
        type: DELETE_OEM_VENDOR,
        payload: oemId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getOemVendor({ page });
          }
        },
      }),
    [oemId]
  );

  const getOemVendor = useCallback(
    (data = {}) => {
      dispatch({
        type: FETCH_OEM_VENDOR,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              setPageWiseOemVendorData(res.data.results);
            }
          }
        },
      });
    },
    [pageWiseOemVendorData]
  );

  const getOemVendorDetail = useCallback((id) => {
    dispatch({ type: GET_OEM_VENDOR, payload: id });
  }, []);

  useEffect(() => {
    getOemVendor();
  }, []);

  useEffect(() => {
    setAllOemVendorData(_.filter(oemVendorData, (item) => startsWith(_.get(item, 'name', ''), searchText)));
  }, [searchText, oemVendorList, pageWiseOemVendorData]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getOemVendor(data);
      }
    },
    [sortByItem]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getOemVendor(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getOemVendor(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseFormOemVendor = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setOemId('');
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="OEM" />
        <div className="page-content-wrapper scrollable">
          <div className="oemVendorList-page">
            <Card>
              <div className="oemVendorList-page-wrapper">
                <Row className="oemVendorList-search-box">
                  <Col xl={10} lg={9} md={8} className="oemVendorList-search-inputBox">
                    <SearchBox value={searchText} preIcon={<BsSearch />} onChange={(e) => setSearchText(e.target.value)} />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="oemVendorList-search-boxButton">
                    <Button
                      className="oemVendorList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add OEM
                    </Button>
                  </Col>
                </Row>
                <div className="oemVendorList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>OEM</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th className="action-col">
                            <div className="sorting">
                              <span>Action</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(allOemVendorData) ? (
                          <tr>
                            <td colSpan={6} className="border-0">
                              <div className="empty-data-block">No OEM Data</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(allOemVendorData, (item, key) => {
                            return (
                              <>
                                <tr key={`oemVendor-${key}`}>
                                  <td>{_.get(item, 'name', '')}</td>
                                  <td>
                                    <span
                                      className="oemVendorList-table-editIcon"
                                      onClick={() => {
                                        setShowForm(true);
                                        getOemVendorDetail(_.get(item, 'id', ''));
                                        setIsEdit(true);
                                      }}
                                    >
                                      <FiEdit2 />
                                    </span>
                                    <span
                                      className="oemVendorList-table-deleteIcon"
                                      onClick={() => {
                                        setShowDeleteModal(true);
                                        setOemId(_.get(item, 'id', ''));
                                      }}
                                    >
                                      <RiDeleteBinLine />
                                    </span>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(allOemVendorData) && (
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                      // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <OemVendorForm onClose={handleCloseFormOemVendor} isEdit={isEdit} onSuccess={getOemVendor} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="OEM" onClose={handleCloseDeleteModel} onRemove={deleteOemVendor} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default OemVendorList;
